import { Container, Form, Alert} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Button} from "../ContentStyles";

import useBackend, {CallAPI, Spinner} from '../../services/useBackend';

import React, { useState, useEffect } from 'react';

const Contact = () => {

    const [resultText, setResultText] = useState("N/A");
    const [resultVariant, setResultVariant] = useState("notset");
    const [resultVisible, setResultVisible] = useState(false);
    const [spinnerHidden, setSpinnerHidden] = useState(true);    

    async function handleSubmit(e) {
        e.preventDefault();
        setSpinnerHidden(false);

        const formData = new FormData(e.target),
        formDataObj = Object.fromEntries(formData.entries())

        let {resultVariant, errorsException, resultVisible, resultText, jsondata} = await CallAPI('/api/contactForm','POST',JSON.stringify(formDataObj));

        setResultVariant(resultVariant);      
        setResultText(resultText);        
        setSpinnerHidden(true);
        setResultVisible(resultVisible);
    }   

    return (
        <ContentWrapper>
            <Container>
            <Sida>
                <Rubrik>Kontakt</Rubrik>
                <Form onSubmit={handleSubmit}>

                    <Form.Group className="mb-3" >
                            <Form.Control type="text" name ="Name" placeholder="Namn"  />
                    </Form.Group>
                    
                    <Form.Group className="mb-3" >
                            <Form.Control type="email" name="Email" placeholder="Email" />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                            <Form.Control type="text" name="Subject" placeholder="Ämne" />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                            <Form.Control as="textarea" rows="3" name="Text"  placeholder='Fråga'/>
                    </Form.Group>

                    <Form.Group className="mb-3"  hidden={spinnerHidden}>
                        <Spinner />
                    </Form.Group>                                      
                        
                    <Form.Group className="mb-3"  hidden={!resultVisible}>
                        <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                    </Form.Group>        

                    <Form.Group className="mb-3">
                        <Button className="QmeButton" variant="primary" type="submit" disabled={resultVariant=="success"? true: false }>Skicka</Button>
                    </Form.Group>   

                </Form> 
            </Sida>
            </Container>
        </ContentWrapper>
    );
};

export default Contact;